import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '../../services/session.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(SessionService);
  const router = inject(Router);
  const currentSession = session.currentSession();

  let authReq = req;
  if (currentSession && currentSession.token) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${currentSession.token}`
      }
    });
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        session.clearSession();
        router.navigate(['/not-found'], {
          state: {
            title: 'Unauthorized',
            errorMessage: 'Your session has expired or you do not have permission to view this page. Please start a new session.'
          }
        });
      }
      return throwError(() => error);
    })
  );
};
